import type { Store } from 'redux';
import { BaseMiddleware } from '@makemydeal/dr-activities-common';
import type { IHostActions } from '../types';
import * as changeVehicleActionCreators from '@makemydeal/dr-activities-change-vehicle';

import * as Actions from '@makemydeal/dr-dash-store/actionTypes/openDealActionTypes';
import * as dealValidationSelectors from '@makemydeal/dr-dash-store/selectors/dealValidationSelectors';
import * as offerActionTypes from '@makemydeal/dr-dash-store/actionTypes/offerActionTypes';
import * as offerMiddleware from '@makemydeal/dr-dash-store/middleware/offerMiddleware';

import type { Selectors } from './selectors';
import * as openDealActionMethods from './actionMethods';

export class MiddlewareManager extends BaseMiddleware {
    constructor(
        public selectors: Selectors,
        public hostActions: IHostActions,
        public baseRoute?: string,
        public analyticsAction?: (store: any, key: string, desc: string) => void
    ) {
        super(selectors, analyticsAction);
    }

    protected middlewareFunction = (store: Store<any>, _next: any, action: any): void => {
        const state = store.getState();

        const isDealValid = dealValidationSelectors.isDealValid(state);
        if (isDealValid) {
            return;
        }
        switch (action.type) {
            case Actions.OPEN_DEAL: {
                store.dispatch(openDealActionMethods.openDealSaveOffer(this.selectors));
                offerMiddleware.syncCustomerToCommonConsumer(state, store);
                break;
            }
            case Actions.SAVE_DEAL_SUCCESS:
            case offerActionTypes.OFFER_SAVE_SUCCESS: {
                store.dispatch(this.hostActions.navigateToDashboard());
                break;
            }
            case Actions.SWITCH_VEHICLE_HIDE_LOADER: {
                store.dispatch(changeVehicleActionCreators.vehicleChangeSuccess());
                break;
            }
        }
    };
}
